import $http from './http'
import config from './config'
export default {
    name: 'huilianyi',
    getUrl(url) {
        return config.getUrl(this.name, url);
    },
    searchapprovals(){
        return $http.post(this.getUrl("/huilianyi/searchApproval"));
    },
    booking(id){
        return $http.get(this.getUrl('/huilianyi/booking?id='+id))
    }
}


// WEBPACK FOOTER //
// ./src/apis/huilianyiapi.js